import { render, staticRenderFns } from "./tradeMarketRecord.vue?vue&type=template&id=506cdec4"
import script from "./tradeMarketRecord.vue?vue&type=script&lang=js"
export * from "./tradeMarketRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports